import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchActiveBanner = async (bannerId: number) => {
	const url = `/homepage/admin/promotion/${bannerId}/`;

	const response = await cmsClient.get<CarouselBanner>(url);

	return response.data;
};

interface Options {
	onSuccess?: (banners: CarouselBanner) => void;
}

const useActivePromotion = (bannerId: number, options: Options = {}) => {
	const query = useQuery(
		["promotion-active-banner", bannerId],
		() => fetchActiveBanner(bannerId),
		{
			...options,
		}
	);

	return query;
};

export default useActivePromotion;
